import Vue from 'vue';
const jurisdiction = function (id) {
    var isLimit=false
    let menuList=this.$store.getters.menuList
    if(menuList){
      for(var v of menuList){
        let libList=v.libList
        if(libList){
          for(var k of libList){
            if(k.libList!=null&&k.libList.length>0){
              for(var j of k.libList){
                if(j.id==id){
                    isLimit=true
                }
              }
            }
           
          }
        }
      }
    }
    return isLimit;
}
Vue.prototype.jurisdiction= jurisdiction
export default { jurisdiction }